import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import BatteryFaultComponent from '../../components/BatteryFaultComponent/BatteryFaultComponent'

const BatteryFault = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <BatteryFaultComponent/>
                </div>
            </div>
        </div>
    )
}

export default BatteryFault
